// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/filepond.min.css
// module id = p2Zr
// module chunks = 1